module.exports = __webpack_public_path__ + "425d9c76c045b14a8de8760b266cd8de.svg";